import { Box } from "@mui/material";

interface CustomLegendProps {
    data: {
        label: string,
        color: string,
    }[]
}

const CustomLegend = ({ data }: CustomLegendProps) => {

    return (
        <div
            style={{
                marginTop: 10,
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: 12,
                fontSize: 12,
            }}
        >
            {data.map((entry, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                        whiteSpace: "nowrap",
                    }}
                >
                    <Box
                        sx={{
                            width: 10,
                            height: 10,
                            backgroundColor: entry.color ?? "black",
                            borderRadius: 0.5,
                        }}
                    />
                    <span style={{ color: "ThemeColors.LightBackgroundContrastText", lineHeight: 1 }}>
                        {entry.label}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default CustomLegend;
